module.exports = __webpack_public_path__ + "website/img/print2.02a0bdee.png";